import { render, staticRenderFns } from "./PvcConf.vue?vue&type=template&id=33dd2d7c&"
import script from "./PvcConf.vue?vue&type=script&lang=js&"
export * from "./PvcConf.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports